"use client";

/**
 * Live-Anbindung — Platzhalter.
 *
 * Im Agent meldet `components/live` jede Schreibung als Ereignis und
 * frischt offene Ansichten auf. clubhub uebernimmt die UI-Bausteine,
 * die daran haengen (Dialog), bekommt die Leitung selbst aber erst mit
 * dem Live-Modul. Bis dahin sind die Haken leere Funktionen: der
 * Dialog ruft `useLiveCover()` und erhaelt einen Aufruf, der nichts tut.
 */
function keineDeckung() {}

export function useLiveCover(): () => void {
  return keineDeckung;
}
